import { orchestrator } from 'satcheljs';
import { calendarEventsLoaderInitialized } from 'owa-calendar-events-loader';
import { isListCalendarCacheId } from '../selectors/agendaStoreSelectors';
import { scrollToUpNext, updateShouldAutoScroll } from '../actions/internalActions';

export const calendarEventsLoaderInitializedOrchestrator = orchestrator(
    calendarEventsLoaderInitialized,
    actionMessage => {
        const { eventsCacheLockId } = actionMessage;
        const isStoredListCalendarCacheId = isListCalendarCacheId(eventsCacheLockId);
        if (isStoredListCalendarCacheId.value) {
            const agendaScenarioId = isStoredListCalendarCacheId.scenarioId;
            updateShouldAutoScroll(true, agendaScenarioId);
            scrollToUpNext(agendaScenarioId);
        }
    }
);
